import {googleAnalyzeEventList} from "@/types/googleAnalyzeEvent";
import {formatDishListToGTag} from "@/utils/formatDishList";
import {useGTagEvent} from "@/hooks";
import {
  formatToCartDishDetailTracking,
  formatToCreatedOrderTracking,
  formatToDishDetailTracking
} from "@/utils/formatToEventTracking";

const {sendEvent: gTagEvent} = useGTagEvent()

// ==== 公共相关 ====

// 访问页面
export function gtag_event_screen_view(view_name: string) {
  gTagEvent(googleAnalyzeEventList.screenView, {screen_name: view_name})
}

// 查看历史订单
export function gtag_event_view_order_history() {
  gTagEvent(googleAnalyzeEventList.historyOrders, {})
}

// 选择取餐时间
export function gtag_event_pickup_choose(data: string) {
  gTagEvent(googleAnalyzeEventList.pickupChoose, {result: data})
}

// 选择店铺
export function gtag_event_change_store() {
  gTagEvent(googleAnalyzeEventList.changeStore, {})
}

// ==== 登录相关 ====

// 登录
export function gtag_event_login() {
  gTagEvent(googleAnalyzeEventList.login, {method: 'phone_num'})
}

// 注册
export function gtag_event_signup() {
  gTagEvent(googleAnalyzeEventList.signup, {method: 'phone_num'})
}

// 退出登录
export function gtag_event_logout() {
  gTagEvent(googleAnalyzeEventList.logout, {})
}

// ==== 支付相关 ====

// 绑定信用卡
export function gtag_event_bind_credit_card(result: string) {
  gTagEvent(googleAnalyzeEventList.creditcardBind, {
    result: result
  })
}

// 创建订单
export function gtag_event_created_order(data: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList.beginCheckout, {
    currency: currency,
    items: formatToCreatedOrderTracking(data)
  })
}

// 支付
export function gtag_event_order_pay(dishList: any, paymentType: string, tax: string, orderId: string, subTotalAmount: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList.purchase, {
    currency: currency,
    items: dishList,
    payment_type: paymentType,
    tax: tax,
    transaction_id: orderId,
    value: subTotalAmount
  })
}

// ==== 快餐 ====

// 购物车变动
export function gtag_event_quick_order_shopping_cart_change(addType: string, dishData: any, count: number, shopName: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList[addType as 'add' | 'minus'], {
    currency: currency,
    items: formatDishListToGTag([{...dishData, count: count}], shopName)
  })
}

// 查看菜品
export function gtag_event_quick_order_view_dish_item(dishData: any, shopName: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList.viewItem, {
    currency: currency,
    items: formatToDishDetailTracking([dishData], shopName)
  })
}

// ==== 桌餐 ====

// 购物车变动
export function gtag_event_table_service_shopping_cart_change(addType: string, dishData: any, count: number, shopName: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList[addType as 'add' | 'minus'], {
    currency: currency,
    items: formatDishListToGTag([{...dishData, count: count}], shopName)
  })
}

// 查看菜品
export function gtag_event_table_service_view_dish_item(dishData: any, shopName: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList.viewItem, {
    currency: currency,
    items: formatToDishDetailTracking([dishData], shopName)
  })
}

// ==== 团单 ====

// 购物车变动
export function gtag_event_group_order_shopping_cart_change(addType: string, dishData: any, count: number, shopName: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList[addType as 'add' | 'minus'], {
    currency: currency,
    items: formatToCartDishDetailTracking([{...dishData, count: count}], shopName)
  })
}

// 查看菜品
export function gtag_event_group_order_view_dish_item(dishData: any, shopName: string, currency: string = 'USD') {
  gTagEvent(googleAnalyzeEventList.viewItem, {
    currency: currency,
    items: formatToCartDishDetailTracking([dishData], shopName)
  })
}
